var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_15809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11.6875C18.9002 15.9225 15.3252 19.25 11 19.25C8.81196 19.25 6.71354 18.3808 5.16637 16.8336C3.61919 15.2865 2.75 13.188 2.75 11C2.75 6.67477 6.0775 3.09977 10.3125 2.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.1875V11H15.8125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.95312C14.2246 3.95312 14.6094 3.56837 14.6094 3.09375C14.6094 2.61913 14.2246 2.23438 13.75 2.23438C13.2754 2.23438 12.8906 2.61913 12.8906 3.09375C12.8906 3.56837 13.2754 3.95312 13.75 3.95312Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 6.01562C17.3184 6.01562 17.7031 5.63087 17.7031 5.15625C17.7031 4.68163 17.3184 4.29688 16.8438 4.29688C16.3691 4.29688 15.9844 4.68163 15.9844 5.15625C15.9844 5.63087 16.3691 6.01562 16.8438 6.01562Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9062 9.10938C19.3809 9.10938 19.7656 8.72462 19.7656 8.25C19.7656 7.77538 19.3809 7.39062 18.9062 7.39062C18.4316 7.39062 18.0469 7.77538 18.0469 8.25C18.0469 8.72462 18.4316 9.10938 18.9062 9.10938Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_15809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountdown);
export default __webpack_public_path__ + "static/media/countdown.866dc77654df6fd4a0de15e07a070971.svg";
export { ForwardRef as ReactComponent };